<template>
    <AppScaffold grid>
        <Card v-if="ladder && !loading">
            <h1>{{ $tradFor(ladder.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <div class="content2">
                <aside><LadderPreview :value="currentLadder"></LadderPreview></aside>
                <section>
                    <label>Ladder type</label>
                    <RadioGroup v-model="form.type" :options="ladderTypeOptions"></RadioGroup>
                    <label v-if="isDoubleLadder">Horizontal spacing between pawls</label>
                    <NumberInput v-if="isDoubleLadder" v-model="form.horizontalSpacingBetweenPawls"></NumberInput>
                    <label>Pawls count</label>
                    <NumberInput v-model="form.pawlsCount"></NumberInput>
                    <label>Pawls interval</label>
                    <NumberInput v-model="form.pawlInterval"></NumberInput>
                </section>
            </div>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService, { LADDER_TYPE, serializeLadder, deserializeLadder, VERITCAL_LADDER_PADDING, SIMPLE_LADDER_SIZE } from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import NumberInput from "@/plano/components/number-input";
import RadioGroup from "@/components/component-form/components/radio-group";
import LadderPreview from "./ladder-preview";

export default {
    components: { Card, RoundedButton, AppScaffold, NumberInput, RadioGroup, Loader, LadderPreview },
    mixins: [TryLoad],
    data: () => ({
        ladder: undefined,
        form: {
            type: LADDER_TYPE.double,
            horizontalSpacingBetweenPawls: 5,
            pawlsCount: 1
        }
    }),
    created() {
        this.fetchLadder();
    },
    computed: {
        ladderTypeOptions() {
            return [{ label: "simple", value: LADDER_TYPE.simple }, { label: "double", value: LADDER_TYPE.double }];
        },
        isDoubleLadder() {
            return this.form.type === LADDER_TYPE.double;
        },
        ladderId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        currentLadder() {
            return deserializeLadder(this.form);
        }
    },
    methods: {
        async fetchLadder() {
            this.ladder = await this.tryLoad(() => componentService.get(this.ladderId));
            const config = this.ladder.config || {
                width: SIMPLE_LADDER_SIZE,
                topPawl: VERITCAL_LADDER_PADDING,
                bottomPawl: VERITCAL_LADDER_PADDING,
                pawlInterval: 10,
                height: 500,
                type: LADDER_TYPE.simple
            };
            this.form = serializeLadder(config);
        },
        async save() {
            try {
                await componentService.updateConfig(this.ladderId, deserializeLadder(this.form));
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.content2 {
    display: flex;
    > aside {
        padding: 30px;
        flex-grow: 1;
        flex-shrink: 0;

        > {
            width: 100%;
            height: 100%;
        }
    }
}

section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-content: start;
    justify-items: start;
    gap: 10px;

    > :nth-child(2n + 1) {
        justify-self: end;
    }
    > :nth-child(2n + 1) {
        text-align: right;
    }

    label {
        text-transform: uppercase;
    }
}
</style>



// WEBPACK FOOTER //
// ladder-config.vue?09ba9867